import { Container, Stack } from '@mui/material';
import { Outlet } from 'react-router';
import { useState } from 'react';
import { useResponsive } from 'src/hooks/useResponsive';

const BuildReport = ({
  title,
  disableHeaderFormBuilder = false,
  reportType,
}: {
  title: string;
  disableHeaderFormBuilder?: boolean;
  reportType: string;
}) => {
  const isTablet = useResponsive('down', 'lg');
  const [disableActions, setDisableActions] = useState(false);
  return (
    <Container maxWidth={false} disableGutters>
      <Stack
        flexDirection={isTablet ? 'column' : 'row'}
        gap="24px"
        sx={{
          marginTop: '24px',
        }}
      >
        <Outlet
          context={{
            title,
            disableHeaderFormBuilder,
            reportType,
            disableActions,
            setDisableActions,
          }}
        />
      </Stack>
    </Container>
  );
};

export default BuildReport;
